import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { UserInfoService } from 'services/user-info/user-info.service';
import { AuthService } from 'services/auth/auth.service';

declare const $: any;

@Component({
	selector: 'user-cmp',
	moduleId: module.id,
	templateUrl: 'user.component.html',
	styleUrls: ['./user.component.css']
})
export class UserComponent implements OnInit {
	constructor(private authService: AuthService, private userInfoService: UserInfoService) {}

	ngOnInit() {
		this.userInfoService
			.getByValue('', this.authService.currentUser.username)
			.subscribe((results) => {
				let result = results[0];
				let firstName = result.name;
				let lastName = result.lastname;
				let lastLogin = new Date(result.last_login).toLocaleString('en-us');
				let description = result.description;
				let phoneNumber = result.phone;
				let emailAddress = result.email;

				$('#user_name').text(this.authService.currentUser.username);
				$('#full_name').text(`${firstName} ${lastName}`);
				$('#last_login').text(lastLogin);
				$('#description').text(description);
				$('#phone_number').text(phoneNumber);
				$('#email_address').text(emailAddress);
			});
	}
}



// WEBPACK FOOTER //
// /Users/baselkilani/work/ODOT/projects/dmscontrol/DmsControl/src/app/user/user.component.ts